"use client";

import React from "react";

import { createStyle } from "~/common/utils/create-style";

type ChatLoaderVariants = "ghost" | "primary";

interface ChatLoaderProps {
  variant?: ChatLoaderVariants;
  dataTestTag?: string;
}

function ChatLoader({ variant, dataTestTag }: ChatLoaderProps) {
  return (
    <div
      className={chatLoaderStyle.container({ variant })}
      role="status"
      data-test={dataTestTag ?? "loader"}
    >
      <div className={chatLoaderStyle.dot()} />
      <div
        className={chatLoaderStyle.dot({ className: "animation-delay-300" })}
      />
      <div
        className={chatLoaderStyle.dot({ className: "animation-delay-600" })}
      />
    </div>
  );
}

const chatLoaderStyle = createStyle({
  slots: {
    container: "flex items-center justify-center gap-2 space-x-2  rounded-l",
    dot: "size-[0.4rem] rounded-full bg-text-secondary animate-float",
  },
  variants: {
    variant: {
      ghost: {
        container: "size-[2rem]",
      },
      primary: {
        container: "bg-overlay-30 size-[4rem]",
      },
    },
  },
  defaultVariants: {
    variant: "primary",
  },
})();

export { ChatLoader };
